import { withRouter, useLocation } from 'react-router-dom';
import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import appConfig from 'app-config';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext, useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { Identify } from "../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent";

import metadata from './MLPELandingPage.metadata.json5';
import styles from './MLPELandingPage.module.scss';

const REPORTS_ROW_LIMIT = 8;
const SECTION_ROW_LIMIT = 6;

function MLPELandingPage(props) {
    const { authUserData, history } = props;

    const { MLUserTypes } = appConfig;

    const isPCS = () => {
        return authUserData?.userType === MLUserTypes.PCS;
    };

    const isIA = () => {
        return authUserData?.userType === MLUserTypes.IA;
    };

    const isMetGA = () => {
        return authUserData?.userType === MLUserTypes.MET_GA;
    };

    const isGCSSales = () => {
        return authUserData?.userType === MLUserTypes.GCS_SALES;
    };

    const isGCSServicing = () => {
        return authUserData?.userType === MLUserTypes.GCS_SERVICING;
    };

    const { authHeader } = useAuthentication();
    const [currentUser, setCurrentUser] = useState({});

    const location = useLocation();
    const isInAgentLandingState = location.pathname === '/';

    const initCurrentUser = useCallback(() => {
        UserService.getCurrentUser(authHeader, false).then((user) => {
            setCurrentUser(user);
        });
    }, [authHeader]);

    useEffect(() => {
        initCurrentUser();

        Identify('Landing Page Reached', {step: 'landing page'}, null);
    }, []);

    const convertLocalDateToDate = (localDate) => {
        const parsedDate = new Date(localDate.year, localDate.month, localDate.day);
        return moment(parsedDate).format('MM/DD/YYYY');
    };

    const onViewAllFollowUpsBtnClicked = () => {
        const reportView = 'followups-report';
        history.push('/activity-reports', {reportView : reportView} );
    }

    const onViewAllArticlesBtnClicked = useCallback(() => {
        window.open('https://foremostproducernews.com', '_blank');
    }, [])

    const onViewAllPoliciesBtnClicked = useCallback(() => {
        history.push('/viewAllPolicies');
    }, [history])

    const overrides = {
        landingPageHeader: {
            visible: isInAgentLandingState
        },
        moratoriumsComponent: {
            currentUser: currentUser,
            visible: !isPCS()
        }, 
        activityReportsComponent: {
            rowLimit: REPORTS_ROW_LIMIT,
            isDashboard: true
        },
        agentFollowUpsContainer: {
            visible: isIA() || isPCS() || isMetGA()
        },
        viewAllFollowUpsButton: {
            onClick: onViewAllFollowUpsBtnClicked,
            mlTagManagerLinkClick: "Dashboard_viewAllFollowUps"
        },
        viewAllArticlesButton: {
            onClick: onViewAllArticlesBtnClicked,
            mlTagManagerLinkClick: "Dashboard_viewAllArticles",
            title: 'Opens in a new tab/window'
        },
        viewAllPoliciesButton: {
            visible: !isGCSSales() && !isGCSServicing(),
            onClick: onViewAllPoliciesBtnClicked,
            mlTagManagerLinkClick: "Dashboard_viewAllPolicies"
        },       
        landingFollowUpsReport: {
            isDashboard: true,
            rowLimit: SECTION_ROW_LIMIT,
            isCompactView: true,
            filterBy: 'user',
            convertLocalDateToDate,
            isPcsIa: isIA() || isPCS(),
            isFromLanding: true
        },
        landingProducerNews: {
            userType: currentUser === {} ? '' : currentUser.userTypeName_ML,
            rowLimit: SECTION_ROW_LIMIT
        },
        producerNewsContainer: {
            visible: !isPCS()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default withRouter(withAuthenticationContext(MLPELandingPage));
